import { render, staticRenderFns } from "./Statuut_Bevoegdheden.vue?vue&type=template&id=468680ae&scoped=true"
import script from "./Statuut_Bevoegdheden.vue?vue&type=script&lang=js"
export * from "./Statuut_Bevoegdheden.vue?vue&type=script&lang=js"
import style0 from "./Statuut_Bevoegdheden.vue?vue&type=style&index=0&id=468680ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468680ae",
  null
  
)

export default component.exports